<template>
  <div class="content-wrapper">
    <app-breadcrumb
        :page-title="pageTitle"
        :directory="$t('datatables')"
        :icon="'grid'"
    />
    <app-table :id="tableId" :options="options" @action="getListAction"/>
    <template v-if="addToScreeningModalShow">
      <app-modal
          :modal-id="modalId"
          modal-alignment="top"
          modal-size="large"
          @close-modal="closeModal"
      >
        <template slot="header">
          <h5 class="modal-title">{{ $t("screening-date") }}</h5>
          <button
              type="button"
              class="close outline-none"
              data-dismiss="modal"
              aria-label="Close">
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
          </button>
        </template>
        <template slot="body">
          <div class="card card-with-search border-0 card-with-shadow">
            <div class="form-group row align-items-center ml-sm-2">
              <label class="col-sm-2 mb-sm-0">Select Screening Date</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="date"
                         v-model="screening.date"
                         placeholder="Select Date"
              />
              <!-- <label class="col-sm-2 mb-sm-0">Select Screening Time</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="time"
                         v-model="screening.time"
                         placeholder="Select Time"
              /> -->
              <label class="col-sm-2 mb-sm-0">Select Deployment Date</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="date"
                         v-model="screening.deployment_date"
                         placeholder="Select Deployment Date"
              />
              <label class="col-sm-2 mb-sm-0">Screening type</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="select"
                         :list="screeningTypeList"
                         v-model="screening.screening_type"
                         v-on:change="screeningTypeOnChange"
              />

              <label class="col-sm-2 mb-sm-0">Select Duration for history check</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="select"
                         v-model="screening.previous_history_duration"
                         placeholder="Select Duration for history check"
                         :list="screeningDuration"
              />
              <label class="col-sm-2 mb-sm-0">Available Credits ({{availableCredits}})</label>
              <app-input class="col-sm-8 mr-sm-2 mb-sm-2"
                         type="text"
                         v-model="screening.availCredit"
                         :read-only="true"
              />
              <el-button class="btn btn-secondary el-button--default col-sm-3"
                         @click.prevent="openLink()">
                Buy Screening Credits
              </el-button>
            </div>
          </div>
        </template>
        <template slot="footer">
          <button
              type="button"
              class="btn btn-success mr-2"
              @click.prevent="save">
            {{ $t("Start Screening") }}
          </button>
          <button
              type="button"
              class="btn btn-secondary mr-2"
              data-dismiss="modal"
              @click="closeModal">
            {{ $t("Cancel") }}
          </button>
        </template>
      </app-modal>
    </template>
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import {TableHelpers} from "../../Demo/Tables/mixins/TableHelpers";
import {SHORT_LIST_CANDIDATES} from '../../../../Config/ScreeningAppUrl'
import {ModalMixin} from "@/app/Mixins/ModalMixin";
import {FormMixin} from "@/core/mixins/form/FormMixin";
import {Candidate, Credits} from "@Views/Screening/utility/apiAgent";
import {screeningTypeList, screeningCreditsByType, screeningDuration} from "@Views/Screening/utility/constant";
import {screeningType} from "@Views/Screening/utility/enums/index";
import {mergeDateTime} from "@Views/Screening/utility/common/candidate";
import AppLibrary from "../../../../Helpers/AppLibrary";


export default {
  extends: AppLibrary,
  name: "ShortListCandidates",
  mixins: [TableHelpers, FormMixin, ModalMixin],
  props: {
    active: Number,
    customerCompany: {},
  },
  data() {
    return {
      pageTitle: this.getPageTitle(),
      id: 0,
      tableId: "advance-table",
      rowData: {},
      options: {
        name: "AdvanceTable",
        url: SHORT_LIST_CANDIDATES,
        showHeader: true,
        columns: [
          {
            title: this.$t("SR. No"),
            type: "text",
            key: "id"
          },
          {
            title: this.$t("name"),
            type: "custom-html",
            key: "forename",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("middle_name"),
            type: "custom-html",
            key: "middle_name",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("Surname"),
            type: "custom-html",
            key: "surname",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("progress"),
            type: "custom-html",
            key: "completion_percentage",
            modifier: (value) => {
              return `<span>${value} %</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "file-plus",
            type: "none",
          },
          {
            title: this.$t("add-to-screening"),
            icon: "file-plus",
            type: "none",
          }
        ],
        filters: [],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      addToScreeningModalShow: false,
      modalId: "add_to_screening_modal",
      screening: {
        date: '',
        // time: '',
        user: '',
        screening_type: '',
        availCredit: 0
      },
      availableCredits: 0,
      isCreditsValid: false,
      screeningTypeList: screeningTypeList,
      screeningDuration: screeningDuration,

    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
  },
  methods: {
    mergeDateTime,
    getPageTitle() {
      let pageTitle = 'Shortlisted Candidates';
      let customerCompany = this.customerCompany;
      if (customerCompany) {
        pageTitle = 'Screening For ' + customerCompany.company_name;
      }
      return pageTitle;
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
      if (actionObj.title == this.$t("view")) {
        window.location.replace(`/candidate-detail/${rowData.company_id}/${rowData.id}`);
      } else if (actionObj.title == this.$t("add-to-screening")) {
        this.getCredits();
      }
    },
    getCredits() {
      Credits.getAvailableCredits()
          .then(({data}) => {
            if (data) {
              const _credits = data.data?.total_credits ?? 0;
              this.availableCredits = _credits;
              this.screening.availCredit = _credits;
              this.addToScreeningModalShow = true;
              return;
            }
            this.$toastr.e("You don't have any credits.");
          });
    },
    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    save() {
      if (!this.isCreditsValid) {
        this.$toastr.e('Credits are not enough, please purchase credits.');
        return;
      }

      // const startDate = this.mergeDateTime(this.screening.date.toString(), this.screening.time.toString());
      // const startDate = this.mergeDateTime(this.screening.date.toString());
      const startDate = this.getDateFormatForBackend(this.screening.date.toString());
      const DeploymentDate = this.getDateFormatForBackend(this.screening.deployment_date);
      const body = {
        applicant_id: this.rowData.id,
        start_date: startDate,
        deployment_date: DeploymentDate,
        company_id: this.rowData.company_id,
        screening_type: this.screening.screening_type,
        previous_history_duration: this.screening.previous_history_duration,
        user: this.screening.user
      };
      Candidate.postScreeningSchedule(body)
          .then(({data}) => {
            this.$toastr.s(data.message);
          })
          .finally(() => {
            this.closeModal();
          });
    },
    openLink() {
      window.location = '/screening-credits';
    },
    screeningTypeOnChange() {
      this.screening.availCredit = this.availableCredits;
      if (this.screening.screening_type === screeningType.Internal) {
        this.screening.availCredit -= screeningCreditsByType.internal;
      } else {
        this.screening.availCredit -= screeningCreditsByType.admin;
      }
      if (this.screening.availCredit < 0) {
        this.screening.availCredit = this.availableCredits;
        this.isCreditsValid = false;
        this.$toastr.e('There are not Enough Credits, for selected Screening Type.');
        return;
      }
      this.isCreditsValid = true;
    },
    closeModal() {
      this.addToScreeningModalShow = false;
      $(`#${this.modalId}`).modal('hide');
    },
  }
};
</script>